// src/Utils/UserIdentity.js

function safeTrim(value) {
  return String(value ?? "").trim();
}

function isBase64UserID(value) {
  const s = safeTrim(value);
  if (!s) return false;
  if (!/^[A-Za-z0-9+/=]+$/.test(s)) return false;

  try {
    const decoded = atob(s);
    return /^user:\d+$/.test(decoded);
  } catch {
    return false;
  }
}

export function normalizeWordPressUserID(raw) {
  const s = safeTrim(raw);
  if (!s) return "";

  if (/^\d+$/.test(s)) {
    try {
      return btoa(`user:${s}`);
    } catch {
      return s;
    }
  }

  if (isBase64UserID(s)) return s;

  return s;
}

export function resolveWordPressUserID(user) {
  const raw =
    user?.id ||
    user?.ID ||
    user?.databaseId ||
    user?.databaseID ||
    user?.user?.id ||
    user?.user?.ID ||
    user?.user?.databaseId ||
    user?.user?.databaseID ||
    "";

  return normalizeWordPressUserID(raw);
}

export function resolveFallbackUserID(user) {
  return (
    safeTrim(user?.sehoUserID) ||
    safeTrim(user?.user?.sehoUserID) ||
    safeTrim(user?.userID) ||
    safeTrim(user?.userId) ||
    safeTrim(user?.user?.userID) ||
    safeTrim(user?.user?.userId) ||
    safeTrim(user?.uid) ||
    safeTrim(user?.user?.uid) ||
    safeTrim(user?.memberID) ||
    safeTrim(user?.memberId) ||
    safeTrim(user?.user?.memberID) ||
    safeTrim(user?.user?.memberId) ||
    safeTrim(user?.username) ||
    safeTrim(user?.user?.username) ||
    safeTrim(user?.email) ||
    safeTrim(user?.user?.email) ||
    ""
  );
}

export function resolveCanonicalUserID(user) {
  return resolveWordPressUserID(user) || normalizeWordPressUserID(resolveFallbackUserID(user));
}